import Body from './body/Body';
import { contactInformation } from '../../utils/contactInformation';
import Header from './header/Header';
import { IDepartmentOptions } from 'src/utils/interfaces/user';
import { isSiteCanadian } from '../../utils/helpers';
import React from 'react';
import Spinner from '../ui/spinner/index';
import { useLocalization } from 'src/utils/useLocalization';

import './contactInfo.scss';

export interface IAdminInfo {
    name: string;
    phone?: string;
    email?: string;
    fax?: string;
}

export interface IOfficeInfo {
    phone?: string;
    email?: string;
    fax?: string;
}

const ContactInfo: React.FC<{
    brand: string;
    admin?: IAdminInfo;
}> = ({ admin, brand }) => {
    const { contactInfo } = useLocalization();
    let adminInfo, dealerInfo;

    function getNumbers(brandName: string) {
        let dealerSupportTeam: IOfficeInfo | undefined = {};
        let departmentOptions: IDepartmentOptions | undefined = {};

        const numberData = isSiteCanadian()
            ? contactInformation.ca
            : contactInformation.us;

        let brandNUmber;
        switch (brandName) {
            case 'audi':
                brandNUmber = numberData.audi;
                break;
            case 'ducati':
                brandNUmber = numberData.ducati;
                break;
            default:
                brandNUmber = numberData.vw;
                break;
        }

        if (brandNUmber.dealerSupport) {
            dealerSupportTeam.phone = brandNUmber.dealerSupport.phone;
        } else {
            dealerSupportTeam = undefined;
        }

        if (brandNUmber.departmentOptions) {
            departmentOptions = brandNUmber.departmentOptions;
        }

        return { dealerSupportTeam, departmentOptions };
    }

    const numbers = getNumbers(brand);
    const dealer = numbers.dealerSupportTeam;
    const departmentOpt = numbers.departmentOptions;

    function isInfoAvailable() {
        return admin || dealer;
    }

    if (admin) {
        adminInfo = {
            name: admin.name,
            isAdmin: true,
            phone: admin.phone,
            email: admin.email,
            fax: admin.fax,
        };
    }

    if (dealer) {
        dealerInfo = {
            name: contactInfo.DEALER_LINE_LABEL,
            isAdmin: false,
            phone: dealer.phone,
            email: dealer.email,
            showDepartment: true,
            departmentOptions: departmentOpt,
        };
    }

    const loader = (
        <div className='loader_container'>
            <Spinner />
        </div>
    );

    return (
        <div className={'contact-info-container'}>
            <Header />
            {isInfoAvailable() ? (
                <Body admin={adminInfo} dealerLine={dealerInfo} />
            ) : (
                loader
            )}
        </div>
    );
};

export default ContactInfo;
